import React from 'react'
import Async from './Functional/Async.jsx'
import AuthRoute from './Auth/AuthRoute.jsx'
import AuthPanel from './Auth/AuthPanel.jsx'
import globalConfig from 'Helper/configHelpers'
import { Routes, Route, Navigate } from 'react-router-dom'
import { PrivChecker, LobbyLoginSettings } from './Config/ConfigPanel.jsx'

// async loads to support code splitting
const AdminDisplay = Async(
  React.lazy(() => import('./AdminDisplay/AdminDisplay.jsx'))
)
const PatientDisplayPanel = Async(
  React.lazy(() => import('./PatientDisplay/PatientDisplayPanel.jsx'))
)
const LobbyApp = Async(
  React.lazy(() => import('../components/Lobby/LobbyApp.jsx'))
)
const LobbyDisplay = Async(
  React.lazy(() =>
    import('../components/Lobby/Dashboard/LobbyDashboard/LobbyDashboard.jsx')
  )
)
const ConfigPanel = Async(
  React.lazy(() => import('../components/Config/ConfigPanel.jsx'))
)
const DashboardPanel = Async(
  React.lazy(() => import('./Dashboard/DashboardPanel.jsx'))
)
const CloudAdminPanel = Async(
  React.lazy(() => import('./Config/CloudAdmin/CloudAdminPanel.jsx'))
)

const OauthLaunch = Async(React.lazy(() => import('./Auth/OauthLaunch.jsx')))

const AppRouter = () => {
  return (
    <Routes>
      {/* The route below (/config/lobby/login would also match the :authProvider/:subProvider/login route
        defined further down and therefor it has to be explicitly defined here rather than in the config
        router like the other config routes. */}
      <Route path={globalConfig.basepath} element={<AuthRoute />}>
        <Route path="config/*" element={<ConfigPanel />}>
          <Route
            path={'lobby/login'}
            element={
              <PrivChecker priv={'lobby_login_settings_read'}>
                <LobbyLoginSettings />
              </PrivChecker>
            }
          />
        </Route>
      </Route>
      <Route path={globalConfig.basepath + 'login'} element={<AuthPanel />} />
      <Route path={globalConfig.basepath + 'logout'} element={<div>logged out</div>} />
      <Route path={globalConfig.basepath + ':authProvider/login'} element={<AuthPanel />} />
      <Route path={globalConfig.basepath + ':subProvider/:authProvider/login'} element={<AuthPanel />} />
      <Route path={globalConfig.basepath + ':authProvider/launch'} element={<OauthLaunch/>} />
      <Route
        path={globalConfig.basepath + 'callback'}
        element={<AuthPanel />}
      />
      <Route
        path={globalConfig.basepath + ':authProvider/callback'}
        element={<AuthPanel />}
      />
      <Route
        path={globalConfig.basepath + ':subProvider/:authProvider/callback'}
        element={<AuthPanel />}
      />
      <Route path={globalConfig.basepath} element={<AuthRoute />}>
        <Route
          index
          element={<Navigate to={globalConfig.basepath + 'dashboard'} />}
        />
        <Route
          path="*"
          element={<Navigate to={globalConfig.basepath + 'dashboard'} />}
        />
        <Route path="xtract/cloud_admin" element={<CloudAdminPanel />} />
        <Route path="dashboard">
          <Route index element={<DashboardPanel />} />
          <Route path="*" element={<DashboardPanel />} />
          <Route path="screen/:screen" element={<DashboardPanel />} />
          <Route path="patient">
            <Route index element={<PatientDisplayPanel />} />
            <Route path=":patientId" element={<PatientDisplayPanel />}>
              <Route path="*" element={<React.Fragment />} />
              <Route path="screen/:screen" element={<React.Fragment />} />
              <Route path="workflow/:workflow" element={<React.Fragment />}>
                <Route path="step/:step" element={<React.Fragment />} />
              </Route>
            </Route>
          </Route>
          <Route path="admin" element={<AdminDisplay />}>
            <Route path="*" element={<React.Fragment />} />
            <Route path="workflow/:workflow" element={<React.Fragment />}>
              <Route path="step/:step" element={<React.Fragment />}></Route>
            </Route>
            <Route path="screen/:screen" element={<React.Fragment />} />
          </Route>
        </Route>
        <Route path="config/*" element={<ConfigPanel />} />
        <Route path="lobby/dashboard" element={<LobbyDisplay />} />
        <Route path="lobby/*" element={<LobbyApp />} />
      </Route>
    </Routes>
  )
}

export default AppRouter
